import { AxiosResponse } from "axios";
import { Axios, CustomAxiosRequestConfig } from "../../Axios";
import { TypeSessaoDaAreaRestrita } from "../../../Models/Domain/AreaRestrita/Sessao";
import { TypeResponsavel } from "../../../Models/Domain/Pessoa/Responsavel";
import { TypeAluno } from "../../../Models/Domain/Pessoa/Aluno";

export type LoginComEmail = {senha: string, email: string};
export type LoginComUsuario = {senha: string, usuario: string};
export type CredenciaisDeLogin = | LoginComEmail | LoginComUsuario;

export type PayloadDeCadastroDeResponsavel = {
    credenciais: Omit<Required<TypeUsuarioDaAreaRestrita>, "codigo" | "usuario">,
    responsavel: TypeResponsavel
}

export type PayloadDeCadastroDeAlunoParaResponsavel = {
    aluno: TypeAluno,
    senhaDaViagem: string
}

export type PayloadDePrimeiraSenha = {
    credenciais: LoginComUsuario,
    novaSenha: string
}

export type PayloadDeNovaSenha = {
    senhaAtual: string,
    novaSenha: string
}

export type PayloadDeRecuperacaoDeSenha = | { email: string } | { usuario: string };

export class AreaRestritaUsuarioService {

    public logar(credenciais: CredenciaisDeLogin): Promise<AxiosResponse<TypeSessaoDaAreaRestrita>> {
        return Axios.post<TypeSessaoDaAreaRestrita>(`quiron/area-restrita/usuario/login`, credenciais);
    }

    public validarToken(token: string): Promise<AxiosResponse<TypeSessaoDaAreaRestrita>> {
        return Axios.post<TypeSessaoDaAreaRestrita>(`quiron/area-restrita/usuario/validar-token`, token);
    }

    public cadastrarResponsavel(payload: PayloadDeCadastroDeResponsavel): Promise<AxiosResponse<TypeResponsavel>> {
        return Axios.post<TypeResponsavel>(`quiron/area-restrita/usuario/cadastro/responsavel`, payload);
    }

    public cadastrarAlunoParaResponsavel(payload: PayloadDeCadastroDeAlunoParaResponsavel): Promise<AxiosResponse<TypeResponsavel>> {
        return Axios.post<TypeResponsavel>(`quiron/area-restrita/usuario/cadastro/responsavel/aluno`, payload);
    }

    public configurarPrimeiraSenhaDaEscola(payload: PayloadDePrimeiraSenha): Promise<AxiosResponse<void>> {
        return Axios.patch<void>(`quiron/area-restrita/usuario/escola/primeira-senha`, payload);
    }

    public recuperarSenha(payload: PayloadDeRecuperacaoDeSenha): Promise<AxiosResponse<void>> {
        return Axios.post<void>(`quiron/area-restrita/usuario/recuperar-senha`, payload);
    }

    public alterarSenha(payload: PayloadDeNovaSenha, config?: CustomAxiosRequestConfig): Promise<AxiosResponse<void>> {
        return Axios.patch<void>(`quiron/area-restrita/usuario/alterar-senha`, payload, config);
    }
}